/**
 * base64url codec (RFC 4648 §5) — URL- and filename-safe, no padding.
 * Used everywhere the protocol crosses the JSON boundary because MLS blobs
 * and signatures are binary.
 */

export type Base64Url = string & { readonly __brand: 'base64url' };

const BASE64URL_PATTERN = /^[A-Za-z0-9_-]*$/;

export function isBase64Url(value: string): value is Base64Url {
  return BASE64URL_PATTERN.test(value);
}

export function toBase64Url(bytes: Uint8Array): Base64Url {
  let binary = '';
  for (const byte of bytes) binary += String.fromCharCode(byte);
  const standard = btoa(binary);
  return standard.replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '') as Base64Url;
}

export function fromBase64Url(value: string): Uint8Array {
  if (!isBase64Url(value)) {
    throw new Error('not a base64url string');
  }
  const padded = value.replace(/-/g, '+').replace(/_/g, '/');
  const padLength = (4 - (padded.length % 4)) % 4;
  const binary = atob(padded + '='.repeat(padLength));
  const out = new Uint8Array(binary.length);
  for (let i = 0; i < binary.length; i++) out[i] = binary.charCodeAt(i);
  return out;
}
